import React from "react";

function MoodChanges() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#a44f3e"
        d="M132.499 171.204l1.596.002a24.951 24.951 0 0115.369-5.28h10.003v-16.384c0-13.161 10.707-23.868 23.868-23.868h100.95c13.161 0 23.868 10.707 23.868 23.868v16.384h10.003a24.96 24.96 0 0115.64 5.493l1.575.002c8.683-5.81 14.402-15.704 14.402-26.936 0-13.756-8.579-25.5-20.675-30.197a32.24 32.24 0 003.708-15.047c0-17.889-14.502-32.39-32.39-32.39-3.065 0-6.026.435-8.836 1.23-1.214-16.781-15.204-30.021-32.295-30.021-10.178 0-19.254 4.698-25.192 12.04-5.938-7.341-15.015-12.04-25.192-12.04-17.091 0-31.08 13.24-32.295 30.021a32.401 32.401 0 00-8.836-1.23c-17.889 0-32.39 14.502-32.39 32.39a32.24 32.24 0 003.708 15.047c-12.096 4.697-20.675 16.441-20.675 30.197 0 11.093 5.581 20.881 14.086 26.719z"
        data-original="#a44f3e"
      ></path>
      <path
        fill="#883f2e"
        d="M231.003 46.795c-5.788-5.413-13.553-8.737-22.102-8.737-17.091 0-31.08 13.24-32.295 30.021a32.401 32.401 0 00-8.836-1.23c-17.889 0-32.39 14.502-32.39 32.39a32.24 32.24 0 003.708 15.047c-12.096 4.697-20.675 16.441-20.675 30.197 0 11.095 5.581 20.883 14.086 26.72a25.98 25.98 0 0116.965-6.278h9.003v-15.384c0-9.522 5.354-17.791 13.214-21.969 6.845-34.889 29.065-64.267 59.322-80.777z"
        data-original="#883f2e"
      ></path>
      <path
        fill="#01c0fa"
        d="M319.501 449.778c-18.379-14.709-31.489-35.351-36.916-58.123l-.082-.344-27.203-21.004a4.12 4.12 0 01-1.614-3.285c0-1.297.588-2.494 1.614-3.287l27.203-21.004.082-.344c5.16-21.654 16.853-40.539 32.769-54.642H257.58v6.192c0 13.107-10.664 23.771-23.771 23.771s-23.77-10.663-23.77-23.771v-6.192h-64.987c.043 1.018.078 2.039.078 3.067 0 36.245-26.901 66.313-61.782 71.32v84.452c0 5.69 4.612 10.302 10.302 10.302h235.874a107.917 107.917 0 01-10.023-7.108z"
        data-original="#01c0fa"
      ></path>
      <path
        fill="#08a9f1"
        d="M127.032 446.583V340.031c-11.181 12.245-26.462 20.684-43.683 23.111v83.441c0 5.69 4.612 10.302 10.302 10.302h43.683c-5.689 0-10.302-4.612-10.302-10.302z"
        data-original="#08a9f1"
      ></path>
      <path
        fill="#ffb09e"
        d="M255.484 266.108h-43.348c-1.04 0-2.071-.039-3.096-.098v27.928c0 13.68 11.09 24.77 24.77 24.77s24.77-11.09 24.77-24.77V266.01a53.813 53.813 0 01-3.096.098z"
        data-original="#ffb09e"
      ></path>
      <path
        fill="#f89580"
        d="M229.215 293.937v-27.829h-17.08c-1.04 0-2.071-.039-3.096-.098v27.928c0 13.68 11.09 24.77 24.77 24.77a24.68 24.68 0 0010.088-2.148c-8.65-3.865-14.682-12.537-14.682-22.623zm-69.753-80.503v-48.508h-9.998c-14.408 0-26.088 11.68-26.088 26.088v3.557c0 14.408 11.68 26.088 26.088 26.088h10.506a52.84 52.84 0 01-.508-7.225z"
        data-original="#f89580"
      ></path>
      <path
        fill="#ffb09e"
        d="M318.156 164.926h-9.998v48.508a52.83 52.83 0 01-.508 7.225h10.506c14.408 0 26.088-11.68 26.088-26.088v-3.557c-.001-14.409-11.681-26.088-26.088-26.088z"
        data-original="#ffb09e"
      ></path>
      <path
        fill="#ffcebf"
        d="M255.484 267.102h-43.348c-29.64 0-53.669-24.028-53.669-53.669v-63.892c0-13.734 11.134-24.868 24.868-24.868h100.95c13.734 0 24.868 11.134 24.868 24.868v63.892c-.001 29.641-24.029 53.669-53.669 53.669z"
        data-original="#ffcebf"
      ></path>
      <path
        fill="#ffb09e"
        d="M184.639 213.434v-63.892c0-13.734 11.134-24.868 24.868-24.868h-26.172c-13.734 0-24.868 11.134-24.868 24.868v63.892c0 29.64 24.028 53.669 53.669 53.669h26.172c-29.641-.001-53.669-24.029-53.669-53.669z"
        data-original="#ffb09e"
      ></path>
      <path
        fill="#ec806b"
        d="M233.81 245.304c-11.639 0-23.277-4.43-32.138-13.29a7.5 7.5 0 0110.606-10.607c11.872 11.873 31.19 11.873 43.062 0a7.501 7.501 0 0110.606 10.607c-8.859 8.86-20.498 13.29-32.136 13.29zm-.002-29.339a7.468 7.468 0 01-5.073-1.979l-11.749-10.799a7.5 7.5 0 01-1.165-9.682l11.749-17.624a7.5 7.5 0 1112.48 8.32l-8.189 12.284 7.024 6.457a7.5 7.5 0 01.447 10.597 7.48 7.48 0 01-5.524 2.426zm52.278-37.291a7.479 7.479 0 01-5.485-2.384c-2.693-2.887-6.233-4.476-9.969-4.476-3.735-.001-7.276 1.589-9.97 4.477a7.501 7.501 0 01-10.967-10.235c5.562-5.96 12.998-9.242 20.937-9.242 7.939 0 15.375 3.282 20.936 9.243a7.5 7.5 0 01-5.482 12.617zm-73.645 0a7.479 7.479 0 01-5.485-2.384c-2.693-2.887-6.233-4.476-9.969-4.476s-7.275 1.589-9.969 4.476a7.5 7.5 0 01-10.968-10.233c5.562-5.961 12.997-9.243 20.937-9.243s15.375 3.282 20.937 9.243a7.5 7.5 0 01-5.483 12.617z"
        data-original="#ec806b"
      ></path>
      <circle
        cx="73.066"
        cy="290.811"
        r="73.066"
        fill="#ffe177"
        data-original="#ffe177"
      ></circle>
      <path
        fill="#ffd15b"
        d="M34.666 290.811c0-34.379 23.75-63.195 55.733-70.979a73.184 73.184 0 00-17.333-2.086C32.713 217.746 0 250.458 0 290.811s32.713 73.066 73.066 73.066c5.974 0 11.775-.734 17.333-2.086-31.984-7.784-55.733-36.601-55.733-70.98z"
        data-original="#ffd15b"
      ></path>
      <path
        fill="#fe99a0"
        d="M35.982 295.161a2.822 2.822 0 00-2.816 3.024c1.546 20.685 18.819 36.988 39.899 36.988s38.354-16.302 39.899-36.988a2.821 2.821 0 00-2.816-3.024z"
        data-original="#fe99a0"
      ></path>
      <path
        fill="#fd8087"
        d="M59.243 298.185a2.821 2.821 0 012.816-3.024H35.982a2.821 2.821 0 00-2.816 3.024c1.546 20.685 18.819 36.988 39.899 36.988 4.566 0 8.951-.767 13.039-2.176-14.785-5.094-25.65-18.607-26.861-34.812z"
        data-original="#fd8087"
      ></path>
      <path
        fill="#c57a44"
        d="M97.421 280.045c-11.33 0-20.547-9.218-20.547-20.547 0-4.143 3.358-7.5 7.5-7.5s7.5 3.357 7.5 7.5c0 3.059 2.489 5.547 5.547 5.547s5.547-2.488 5.547-5.547c0-4.143 3.358-7.5 7.5-7.5s7.5 3.357 7.5 7.5c0 11.329-9.217 20.547-20.547 20.547zm-48.711 0c-11.33 0-20.547-9.218-20.547-20.547 0-4.143 3.358-7.5 7.5-7.5s7.5 3.357 7.5 7.5c0 3.059 2.489 5.547 5.547 5.547s5.547-2.488 5.547-5.547c0-4.143 3.358-7.5 7.5-7.5s7.5 3.357 7.5 7.5c.001 11.329-9.216 20.547-20.547 20.547z"
        data-original="#c57a44"
      ></path>
      <path
        fill="#ffe177"
        d="M462.309 292.709a73.77 73.77 0 01-24.224 4.082c-27.007 0-50.62-14.49-63.517-36.114-45.524 4.668-82.57 37.896-92.955 81.478l-26.924 20.789c-2.671 2.062-2.671 6.092 0 8.154l26.924 20.789c11.212 47.053 53.497 82.055 103.983 82.055 59.563 0 107.751-48.704 106.91-108.46-.397-28.141-11.838-53.813-30.197-72.773z"
        data-original="#ffe177"
      ></path>
      <path
        fill="#ffd15b"
        d="M462.309 292.709l-1.522-.555a72.602 72.602 0 01-22.703 3.637c-26.136 0-49.093-13.83-61.968-34.548l-1.549-.566c-45.524 4.668-82.57 37.896-92.955 81.478l-26.924 20.789c-2.671 2.062-2.671 6.092 0 8.154l26.924 20.789c11.212 47.053 53.497 82.055 103.983 82.055 59.563 0 107.751-48.704 106.91-108.46-.396-28.141-11.837-53.813-30.196-72.773z"
        data-original="#ffd15b"
      ></path>
      <path
        fill="#ffc344"
        d="M413.352 457.76c-58.749 0-106.374-47.625-106.374-106.374 0-34.707 16.624-65.527 42.341-84.944-33.564 12.111-59.324 40.534-67.706 75.714l-26.924 20.789c-2.671 2.062-2.671 6.092 0 8.154l26.924 20.789c11.212 47.053 53.497 82.055 103.983 82.055 25.434 0 48.79-8.886 67.144-23.716-12.183 4.857-25.472 7.533-39.388 7.533z"
        data-original="#ffc344"
      ></path>
      <path
        fill="#c57a44"
        d="M388.505 432.379c-36.421 0-66.052-29.631-66.052-66.053 0-4.143 3.358-7.5 7.5-7.5s7.5 3.357 7.5 7.5c0 28.15 22.902 51.053 51.052 51.053s51.052-22.902 51.052-51.053c0-4.143 3.358-7.5 7.5-7.5s7.5 3.357 7.5 7.5c0 36.422-29.631 66.053-66.052 66.053zm-24.185-77.646a7.5 7.5 0 01-7.5-7.5v-16.547c0-4.143 3.358-7.5 7.5-7.5s7.5 3.357 7.5 7.5v16.547a7.5 7.5 0 01-7.5 7.5zm48.369 0a7.5 7.5 0 01-7.5-7.5v-16.547c0-4.143 3.358-7.5 7.5-7.5s7.5 3.357 7.5 7.5v16.547c0 4.143-3.357 7.5-7.5 7.5z"
        data-original="#c57a44"
      ></path>
      <circle
        cx="438.085"
        cy="222.876"
        r="73.915"
        fill="#fff0ad"
        data-original="#fff0ad"
      ></circle>
      <path
        fill="#ffe177"
        d="M399.195 222.876c0-34.786 24.037-63.943 56.402-71.81a74.052 74.052 0 00-17.513-2.106c-40.822 0-73.915 33.093-73.915 73.915s33.093 73.915 73.915 73.915a74 74 0 0017.513-2.106c-32.365-7.865-56.402-37.022-56.402-71.808z"
        data-original="#ffe177"
      ></path>
      <path
        fill="#fe99a0"
        d="M400.57 227.276a2.855 2.855 0 00-2.849 3.06c1.564 20.926 19.038 37.418 40.364 37.418s38.8-16.492 40.364-37.418a2.855 2.855 0 00-2.849-3.06z"
        data-original="#fe99a0"
      ></path>
      <path
        fill="#fd8087"
        d="M423.538 230.335a2.854 2.854 0 012.849-3.059H400.57a2.855 2.855 0 00-2.849 3.059c1.564 20.926 19.038 37.418 40.364 37.418 4.515 0 8.854-.746 12.909-2.11-15.1-5.079-26.223-18.812-27.456-35.308z"
        data-original="#fd8087"
      ></path>
      <path
        fill="#c57a44"
        d="M416.089 210.597a7.5 7.5 0 01-7.5-7.5v-17.384c0-4.143 3.358-7.5 7.5-7.5s7.5 3.357 7.5 7.5v17.384a7.5 7.5 0 01-7.5 7.5zm43.991 0a7.5 7.5 0 01-7.5-7.5v-17.384c0-4.143 3.358-7.5 7.5-7.5s7.5 3.357 7.5 7.5v17.384a7.5 7.5 0 01-7.5 7.5z"
        data-original="#c57a44"
      ></path>
      <path
        fill="#ffd15b"
        d="M404.275 104.825h-9.462v-9.462c0-4.143-3.358-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v9.462h-9.462c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h9.462v9.463c0 4.143 3.358 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-9.463h9.462c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5zM86.979 158.323h-9.463v-9.462c0-4.143-3.358-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v9.462h-9.462c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h9.462v9.463c0 4.143 3.358 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-9.463h9.463c4.142 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5zm72.184 220.459h-9.462v-9.462c0-4.143-3.358-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v9.462h-9.463c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h9.463v9.463c0 4.143 3.358 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-9.463h9.462c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5z"
        data-original="#ffd15b"
      ></path>
    </svg>
  );
}

export default MoodChanges;